import { render } from "./MonthlyTargets.vue?vue&type=template&id=2c14df85&scoped=true"
import script from "./MonthlyTargets.vue?vue&type=script&lang=js"
export * from "./MonthlyTargets.vue?vue&type=script&lang=js"

import "./MonthlyTargets.vue?vue&type=style&index=0&id=2c14df85&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c14df85"]])

export default __exports__